import { render, staticRenderFns } from "./FormBuilderPreview.vue?vue&type=template&id=5ae1ac8a&scoped=true"
import script from "./FormBuilderPreview.vue?vue&type=script&lang=js"
export * from "./FormBuilderPreview.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderPreview.vue?vue&type=style&index=0&id=5ae1ac8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae1ac8a",
  null
  
)

export default component.exports